__turbopack_context__.v({
  "app_light_theme": "product-toggle-button-module-scss-module__olfzAa__app_light_theme",
  "icon": "product-toggle-button-module-scss-module__olfzAa__icon",
  "productToggleButton": "product-toggle-button-module-scss-module__olfzAa__productToggleButton",
  "text": "product-toggle-button-module-scss-module__olfzAa__text",
});
